import { render, staticRenderFns } from "./transferoperasyon.vue?vue&type=template&id=c0d243f0&scoped=true&"
import script from "./transferoperasyon.vue?vue&type=script&lang=js&"
export * from "./transferoperasyon.vue?vue&type=script&lang=js&"
import style0 from "./transferoperasyon.vue?vue&type=style&index=0&id=c0d243f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d243f0",
  null
  
)

export default component.exports